import { useMutation, useQueryClient } from '@tanstack/react-query';
import { syncDeficiencyWithAnswer } from '../services/DeficiencyServices';
export default function useSyncDeficiencyWithAnswer(deficiencyId) {
    const queryClient = useQueryClient();
    const syncWithAnswer = useMutation(() => syncDeficiencyWithAnswer(deficiencyId), {
        onSuccess: (updatedDeficiency) => {
            queryClient.setQueryData(['deficiency', deficiencyId], updatedDeficiency);
        },
        onSettled: () => {
            void queryClient.invalidateQueries(['deficiency', deficiencyId]);
        }
    });
    return { syncWithAnswer };
}
